import { render, staticRenderFns } from "./ManageTagForm.vue.vue?vue&type=template&id=3f404536&"
import script from "./ManageTagForm.vue.vue?vue&type=script&lang=js&"
export * from "./ManageTagForm.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports